const projects = [
    {
        id: 1,
        title: "Course Correct",
        description: "React app that pulls down all the courses from Udemy with a rating of more than 4 stars and displays them by category. Also allows users to add their own courses.",
        items: [
            "Visual Design",
            "Webscraping",
            "API Design & Integration",
        ],
        tech: ["MongoDB | Express | React | NodeJS"],
        link: "https://course-correct.netlify.app/",
        github: "https://github.com/secondaryfun/course-correct"
    },
    {
        id: 2,
        title: "Inkyy Rocketship Website",
        description: "A website skeleton build in HTML and CSS. No Javascript allows on this mockup. Built from an Adobe XD design by Inkyy.com.",
        items: [
            "HTML & CSS Implementation",
            "Game Logic",
            "Development",
            "Stat Design"
        ],
        tech: ["HTML | CSS"],
        link: "https://secondaryfun.github.io/Inkyy-Rocketship-Website/",
        github: "https://github.com/secondaryfun/Inkyy-Rocketship-Website",
    },
    {
        id: 2,
        title: "Boo-Booty Checkers",
        description: "2-Player Checkers with a training mode.",
        items: [
            "Visual Design",
            "Game Design",
            "Development",
        ],
        tech: ["HTML | CSS | Javascript"],
        link: "https://secondaryfun.github.io/Boo-Booty-Checkers/",
        github: "https://github.com/secondaryfun/Boo-Booty-Checkers"
    },
    {
        id: 3,
        title: "API Slider - DnD Spellbook",
        description: "React App that serves up DnD spells from a web API.  Checkout the alternate view for some fun with CSS. ",
        items: [
            "Visual Design",
            "API Connection",
            "Development",
            "Pattern Design"
        ],
        tech: ["React | HTML | CSS | Javascript"],
        link: "https://dnd-spellbook.netlify.app/",
        github: "https://github.com/secondaryfun/DnD-Spellbook-with-React"
    },
    {
        id: 5,
        title: "Game of War",
        description: "It's the card game war, played in your browser's console. Start the game in the console with 'war.runGame(true)', or run multiple games at once so see the stats:  'war.runGame(false,10)'.  false = do not show turns / 10 = # of games. Follow the link to the left to play. The game does not work in an iFrame.",
        items: [
            "Visual Design",
            "Game Logic",
            "Development",
            "Stat Design"
        ],
        tech: ["HTML | CSS | Javascript"],
        link: "https://secondaryfun.github.io/game-of-war/",
        github: "https://github.com/secondaryfun/game-of-war",
    },



]

export default projects
